export default "__VITE_ASSET__TSL$$H5S__"